import { render, staticRenderFns } from "./Photography.vue?vue&type=template&id=61a8b8ee&scoped=true&"
import script from "./Photography.vue?vue&type=script&lang=js&"
export * from "./Photography.vue?vue&type=script&lang=js&"
import style0 from "./Photography.vue?vue&type=style&index=0&id=61a8b8ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a8b8ee",
  null
  
)

component.options.__file = "Photography.vue"
export default component.exports